type MetaProps = {
  fulfillmentMode?: string | null;
  pinnedStoreCity?: string | null;
  pinnedStoreName?: string | null;
  pinnedStoreState?: string | null;
  reservationMode?: string | null;
};

export const createMetaVariables = (
  metaProps: MetaProps = {},
  additionalProps = {}
) => ({
  storeCity: metaProps.pinnedStoreCity ?? '',
  storeFulfillment: metaProps.fulfillmentMode ?? '',
  storeName: metaProps.pinnedStoreName ?? '',
  storeStateAbbr: metaProps.pinnedStoreState ?? '',
  storeType: metaProps.reservationMode ?? '',
  ...additionalProps,
});
